export interface DialogueGameplayPauseTarget {
  setPaused(paused: boolean): void;
}

export interface DialogueGameplayPauseController {
  readonly activeDialogueId: string | null;
  pause(dialogueId: string): void;
  complete(dialogueId: string): void;
  resume(): void;
}

export function createDialogueGameplayPauseController(
  targets: readonly DialogueGameplayPauseTarget[],
): DialogueGameplayPauseController {
  let activeDialogueId: string | null = null;

  const setTargetsPaused = (paused: boolean): void => {
    for (const target of targets) target.setPaused(paused);
  };

  return {
    get activeDialogueId(): string | null {
      return activeDialogueId;
    },
    pause(dialogueId: string): void {
      if (activeDialogueId === dialogueId) return;
      if (activeDialogueId === null) setTargetsPaused(true);
      activeDialogueId = dialogueId;
    },
    complete(dialogueId: string): void {
      if (activeDialogueId !== dialogueId) return;
      activeDialogueId = null;
      setTargetsPaused(false);
    },
    resume(): void {
      if (activeDialogueId === null) return;
      activeDialogueId = null;
      setTargetsPaused(false);
    },
  };
}
